import React from 'react';
import { compose } from 'redux';
import { isExchange } from 'src/utils/transactions-util';
import './MarketVolatilityNote.scss';

import { getMarketVolatilityMessage } from '../../../../redux/modules/marketVolatility/marketVolatility.selectors';

import { connect } from 'react-redux';

const MarketVolatilityNote = ({ message, productType }) => {
  return (
    <div className="market-volatility-note-box">
      <div className="market-volatility-note">
        {isExchange()
          ? productType === 'ManagedAccount'
            ? message?.app?.volatilityMessage
            : message?.mutualFund?.volatilityMessage
          : message}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    message: getMarketVolatilityMessage(state),
  };
};

export default compose(connect(mapStateToProps))(MarketVolatilityNote);
